import React from "react";
import { Link } from "react-router-dom";

export default function RecentBlogBox({ blogdata }) {
  return (
    <>
      <li>
        <div className="post-pic">
          <img
            src={blogdata.sort_img}
            alt={blogdata.image_alt}
            title={blogdata.image_title}
            className="img img-responsive"
          />
        </div>
        <div className="details">
          <h4>
            <Link to={`/blog/${blogdata.slug}`}>{blogdata.title}</Link>
          </h4>
          <span>{blogdata.date}</span>
        </div>
      </li>
    </>
  );
}
